import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import { EditUserContainerConstants } from './constants';
import EditUserRecord from './data/EditUserRecord';
import EditUserUserRecord from './data/EditUserUserRecord';

function getInitialState() {
  return new EditUserRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<EditUserRecord> = (state = defaultState, action) => {
  switch (action.type) {
    case EditUserContainerConstants.CLOSE_EDIT_USER_MODAL:
      return getInitialState();

    case EditUserContainerConstants.OPEN_EDIT_USER_MODAL:
      return state.merge({
        isModalOpen: true,
        userId:
          typeof action.payload === 'object' &&
          action.payload !== null &&
          'userId' in action.payload &&
          typeof action.payload.userId === 'string'
            ? action.payload.userId
            : '',
      });

    case EditUserContainerConstants.GET_USER_REQUEST:
      return state.merge({
        isLoading: true,
        hasLoaded: false,
        user: undefined,
        loadUserError: undefined,
      });

    case EditUserContainerConstants.GET_USER_REQUEST_SUCCESS:
      return state.merge({
        isLoading: false,
        hasLoaded: true,
        user: new EditUserUserRecord(action.response),
      });

    case EditUserContainerConstants.GET_USER_REQUEST_ERROR:
      return state.merge({
        isLoading: false,
        isModalOpen: false,
        loadUserError: new ErrorRecord(
          typeof action.error === 'object' && action.error !== null ? action.error : undefined
        ),
      });

    case EditUserContainerConstants.EDIT_USER_REQUEST:
      return state.merge({
        isSubmitting: true,
        error: undefined,
      });

    case EditUserContainerConstants.EDIT_USER_REQUEST_SUCCESS:
      return state.merge({ isSubmitting: false });

    case EditUserContainerConstants.EDIT_USER_REQUEST_ERROR:
      return state.merge({
        isSubmitting: false,
        error: new ErrorRecord(
          typeof action.error === 'object' && action.error !== null ? action.error : undefined
        ),
      });

    default:
      return state;
  }
};

export default reducer;
